






























































































import { Component, Vue } from 'vue-property-decorator';
import CollapseTransition from '@/components/collapseTransition/collapseTransition';
import { patrolManagementServe } from '@/api/installServer';
import { TableStripe } from '@/mixins/tableStripe';
import TreeUnit from '@/components/tree/treeUnit.vue';
import PagingUnit from '@/components/paging/paging.vue';
import VerifyEdit from './unit/verify-edit.vue';

@Component({
  components: { CollapseTransition, TreeUnit, PagingUnit, VerifyEdit },
  mixins: [TableStripe],
})
export default class PatrolTask extends Vue {
  private selectList: any = [];

  /**
   * 【表格】表格选择变化
   */
  handleTableSelectionChange(val: any) {
    this.selectList = val;
  }

  openAsideFlag = false; // 侧边栏是否打开

  showFlag = 1;
  rowId: any = '';

  queryDataForm: object = {
    pageNo: 1,
    pageSize: 10,
  };
  total = 0; // 数据总共多少条

  private filterForm: any = {
    status: 0,
  };
  private verifyData: any = {};

  // table数据
  tableData: any = [];

  showTree(flag: boolean) {
    this.openAsideFlag = flag;
  }

  getNodeIds(data: any) {
    this.getAllData();
  }

  // 公司（单位）数据
  get orgList() {
    return this.$store.state.user.orgList;
  }

  orgIdToName(id: any) {
    const a: any = this.orgList.find((s: any) => {
      return s.spaceId === id;
    });
    let d: any = '';
    if (a) {
      d = a.name;
    }
    return d;
  }

  /**
   *【表格】表格修改按钮
   * @Params
   * @return
   **/
  handleTableEditBtnClick(data: any) {
    this.verifyData = data;
    const VerifyComponent: any = this.$refs['verifyEdit'];
    VerifyComponent.showEditDialog(data.id);
  }
  /**
   *【岗位编辑窗口】巡检任务配置编辑窗口提交请求成功
   * @Params
   * @return
   **/
  handleEditResponse() {
    this.getAllData();
  }

  /**
   * @desc Vue 创建数据生命周期
   * @param1 暂无
   * @returns 暂无
   */
  created() {
    // 获取所有数据
    this.getAllData();
  }
  /**
   * @desc 获取所有数据
   * @param1 暂无
   * @returns 暂无
   */
  getAllData() {
    patrolManagementServe
      .getPatrolVerifyListData({
        status: this.filterForm.status === 0 || this.filterForm.status === 1 || this.filterForm.status === 2 ? this.filterForm.status : null,
        pageNo: (this.queryDataForm as any).pageNo,
        pageSize: (this.queryDataForm as any).pageSize,
        paging: true,
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.tableData = res.data.records;
          this.total = res.data.total;
        }
      });
  }

  private getListData() {
    this.getAllData();
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击查询按钮触发，查询符合条件的内容
   * @param1 暂无
   * @returns 暂无
   */
  search() {
    // 获取到符合搜索条件的数据
    (this.queryDataForm as any).pageNo = 1;
    this.getAllData();
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击重置按钮触发，重置表单内容
   * @param1 暂无
   * @returns 暂无
   */
  resetForm() {
    (this.$refs.formRef as any).resetFields();
    (this.queryDataForm as any).pageNo = 1;
    // 获取全部数据
    this.getAllData();
  }
}
